import Select from "react-select";

import "../styles/IndicatorsStyle.css";
import {  get_info_element } from "./Indicators";
import DroughtIndicatorModal from "./DroughtIndicatorModal";
import { get_data, base_url } from "../Geoportal";
import { get_custom_list} from "./Indicators";
import {getMonthName} from "./Precipitation"
import {maplibre_str, geoserver} from "../Geoportal";
import {months} from "./SidePanel";


 export const customoptions = (anArray) => {
    // returns the options for selection object
    var opt = anArray.map((item) => {
      return { value: item, label: item };
    });
    return opt;
  };

  export const get_select_element = (
    customoptions,
    array_options,
    onChange,
    placeholder,
    state = false,
    disable = false
  ) => {
    if (state !== false) {
      return (
        <Select
          className="select-indicator"
          classNamePrefix="select-controls-indicators"
          options={customoptions(array_options)}
          placeholder={placeholder}
          value={placeholder}
          //   value = 'Select Country'
          onChange={onChange}
          // onSelectResetsInput={true}
          isSearchable={true}
          isDisabled={disable}
        ></Select>
      );
    }
  };

export const selection_component = (oncheck_func, checked,
                                onclick_info_handler_func, 
                                dataset_name, isInfoVisible, isInfoLoading, InfoDataset,
                                selected_dates, available_dates,
                                yearChangeFunc, monthChangeFunc, timeChangeFunc, timename,
                                extra_select_option=null,
                                download_params=null

                              ) => {
      var timename_extra_option = extra_select_option?.timename
      var timeChangeFunc_extra_option = extra_select_option?.changefunc
      var extra_option_active = extra_select_option?.active

      var downloaddata = download_params?.download || false
  
    return (    <div className="selection-section">
        <div className="selection-section-header">
          <label className="switch">
            <input
              type="checkbox"
              defaultChecked={checked}
              onChange={oncheck_func}
            />
            <span className="slider round"></span>
          </label>
          <p className="indicator-description">
            {dataset_name}
          </p>
          {get_info_element(onclick_info_handler_func)}
        </div>

        {isInfoVisible && (
          <>
                <DroughtIndicatorModal
                dataset={InfoDataset}
                isActive={isInfoVisible}
                toggleModal={onclick_info_handler_func}
                isLoading={isInfoLoading}
                download={downloaddata}
                downloadParams={download_params?.params}
                />

          </>
        )}

        {checked ? (
          <p
            style={{
              position: "relative",
              color: "#000000",
              fontSize: "10px",
              left: "5px",
              marginTop: "10px",
             
            }}
          >
            {selected_dates["year"]}{" "}
            {selected_dates["month"]}{" "}
            {timename+" " +selected_dates[timename]}{" "} {extra_select_option !== null && checked  && extra_option_active ? <>{
              timename_extra_option + " " + selected_dates[timename_extra_option]
            }</>: <></>}
          </p>
        ) : (
          <></>
        )}

        <div className="selection-row">
          {get_select_element(
            customoptions,
            available_dates["year"],
            yearChangeFunc,
            selected_dates["year"],
            checked
          )}

          {get_select_element(
            customoptions,
            available_dates["month"],
            monthChangeFunc,
            selected_dates["month"],
            checked
          )}

           {get_select_element(
            customoptions,
            available_dates[timename],
            timeChangeFunc,
            selected_dates[timename],
            checked
          )}
        {extra_select_option !== null && checked ? <>{
        get_select_element(
            customoptions,
            available_dates[timename_extra_option],
            timeChangeFunc_extra_option,
            selected_dates[timename_extra_option],
            extra_option_active
          )
        }</>: <></>}
          
        </div>
      </div>)
  }

export  const handleInfoClickGeneral = (
          isInfoVisible,
          setInfoVisible,
          setLoadingInfo,
          setInfoData,
          dataset_id
        ) => {
          setInfoVisible(!isInfoVisible);

          if (!isInfoVisible) {
            setLoadingInfo(true);
            const url = `${base_url}/api/metadata/?dataset_id=${dataset_id}`;
            get_data(url)
              .then((data) => {
                setInfoData(data[0]);
                setLoadingInfo(false);
              })
              .catch((error) => {
                console.error(`Failed to fetch ${dataset_id} info:`, error);
                setLoadingInfo(false);
              });
          }
        };


export const oncheckGeneral = (checked, setter_func) =>{
    setter_func(!checked);
  }



 var dekads_names = { "01": "1st", 11: "2nd", 21: "3rd" };

export const zfill = (num, size = 2) => String(num).padStart(size, '0'); // handles single digit to two digit conversion

 export  function get_dekad_name(dekad) {
    return dekads_names[dekad];
  }
  
export function set_innitial_selected_datasets_general(data, layername,
                                                      years_setter=null, selected_dates_setter=null,
                                                    setter_current=null, latest_dates_setter=null, dates_setter=null, key_current=null) {
    var latest_year = data?.latest_year;
    var start_year = data?.start_year;
    var latest_dekad = zfill(data?.latest_dekad);

    var years = get_custom_list(start_year, latest_year);

    var latest_dekad_list = data[latest_year]?.dekads || [];

    var default_list_dekads = ["1st", "2nd", "3rd"];

    var start_month = data?.start_month;

    var set_start_month = 1;

    if (start_year === latest_year && start_month !== undefined){
        set_start_month = start_month;
    }

    if (latest_dekad_list.length > 0){
        latest_dekad_list = latest_dekad_list.map(v => zfill(v));
    }

    if (years_setter !== null){
      years_setter(years);
    }
    var selected_month = getMonthName(data?.latest_month);
    // handle case where the current selected month is not in the available months 
    var month_names_list = get_custom_list(set_start_month, data?.latest_month).map(getMonthName);

   
  
    var geosever_link = `${geoserver}${maplibre_str}${layername}${months[selected_month]}${latest_dekad}_view&CQL_FILTER=year=${latest_year}`;

     latest_dekad = get_dekad_name(latest_dekad);
  
      selected_dates_setter({
        year: latest_year,
        month: selected_month,
        dekad: latest_dekad
      });

    if (key_current !== null){
       setter_current({[key_current]:geosever_link});
    }else {
        setter_current(geosever_link);
    }
    

    latest_dates_setter({
      latest_year: latest_year,
      latest_dekad: latest_dekad,
      latest_month: data?.latest_month
    });

    dates_setter({
      year:years,
      month:month_names_list,
      dekad: latest_dekad_list.length > 0 
           ? latest_dekad_list.map(get_dekad_name) 
           : default_list_dekads 
    });
    
   
  }


  export const selection_component_general_longrange = (oncheck_func, checked,
                                onclick_info_handler_func, 
                                dataset_name, isInfoVisible, isInfoLoading, InfoDataset,
                                selected_dates, available_dates,
                                yearChangeFunc,timeChangeFunc, timename,
                                extra_select_option=null,
                                download_params=null) => {
      var timename_extra_option = extra_select_option?.timename
      var extra_option_active = extra_select_option?.active

      var downloaddata = download_params?.download || false

  
    return (    <div className="selection-section">
        <div className="selection-section-header">
          <label className="switch">
            <input
              type="checkbox"
              defaultChecked={checked}
              onChange={oncheck_func}
            />
            <span className="slider round"></span>
          </label>
          <p className="indicator-description">
            {dataset_name}
          </p>
          {get_info_element(onclick_info_handler_func)}
        </div>

        {isInfoVisible && (
          <>
                <DroughtIndicatorModal
                dataset={InfoDataset}
                isActive={isInfoVisible}
                toggleModal={onclick_info_handler_func}
                isLoading={isInfoLoading}
                download={downloaddata}
                downloadParams={download_params?.params}
                />

          </>
        )}

        {checked ? (
          <p
            style={{
              position: "relative",
              color: "#000000",
              fontSize: "10px",
              left: "5px",
              marginTop: "10px",
             
            }}
          >
            {selected_dates["year"]}{" "}
            {timename+" " +selected_dates[timename]}{" "} {extra_select_option !== null && checked  && extra_option_active ? <>{
              timename_extra_option + " " + selected_dates[timename_extra_option]
            }</>: <></>}
          </p>
        ) : (
          <></>
        )}

        <div className="selection-row">
          {get_select_element(
            customoptions,
            available_dates["year"],
            yearChangeFunc,
            selected_dates["year"],
            checked
          )}

           {get_select_element(
            customoptions,
            available_dates[timename],
            timeChangeFunc,
            selected_dates[timename],
            checked
          )}
    
          
        </div>
      </div>)
  }

